import TabContainer from './tab_container';

export default TabContainer;
